<template>
  <div v-if="isPreview" class="preview">预览模式</div>
  <div v-if="loading" style="text-align: center; padding: 40px">
    <van-loading size="30px" type="spinner" vertical>加载中..</van-loading>
  </div>
  <div v-if="step == 1 && !loading" class="h100 step-1 flex flex-v">
    <!-- <div class=""> -->
    <!-- <h2>{{ detail.SurveyTitle }}</h2>
      <div class="desc ql-editor" v-html="detail.Profile"></div> -->
    <div class="flex flex-pack-center" style="margin-top: 100px">
      <van-image
        class="avatar-image"
        hight="112"
        radius="16"
        :src="api.FileHost + tenant.LogoSmall"
        width="112"
      />
    </div>
    <div class="detail-content">
      <div class="survery-title">{{ detail.SurveyTitle }}</div>
      <div class="survery-sub-title">{{ detail.SurveySubtitle }}</div>
      <div class="desc ql-editor" v-html="detail.Profile"></div>
    </div>
    <!-- </div> -->

    <div class="btn-box">
      <div class="btn-box-2">
        <van-button
          color="#000"
          round
          size="large"
          type="primary"
          @click="step = 2"
        >
          开始测评
        </van-button>
      </div>
    </div>
  </div>

  <div v-if="step == 2" class="h100 step-2 flex flex-v">
    <div class="progress-div">
      <div class="flex flex-align-center top">
        <div class="progress-title">答题进度</div>
        <div>
          <span class="done-total">{{ getAnswerTotal() }}</span>
          <span class="total">/{{ total }}</span>
        </div>
        <div class="flex-1"></div>
        <a
          class="top-submit"
          :class="{ disabled: getAnswerTotal() < total }"
          href="javascript:;"
          @click.stop="handleExam"
        >
          交卷
        </a>
      </div>
      <van-progress
        color="#FAAD14"
        :percentage="(getAnswerTotal() / total) * 100"
        :show-pivot="false"
        stroke-width="8"
        track-color="#f0f2f4"
      />
    </div>
    <div class="question">
      <transition-group name="list">
        <div
          v-for="(item, index2) in detail.Stems"
          v-show="index2 === index"
          :key="index2"
        >
          <div class="question-title">{{ index2 + 1 }} {{ item.Stem }}</div>
        </div>
      </transition-group>
    </div>
    <div class="flex-1 step-2-content">
      <!-- <nav-bar :title="getTitle">
      <template #left>&nbsp;</template>
      <template #right>
        <a
          class="top-submit"
          :class="{ disabled: getAnswerTotal() < total }"
          href="javascript:;"
          @click.stop="handleExam"
        >
          交卷
        </a>
      </template>
    </nav-bar> -->

      <!-- <div class="question">
      <h2>{{ index + 1 }} {{ detail.Stems[index].Stem }}</h2>
    </div> -->
      <div class="option">
        <div class="answer-list">
          <div
            v-for="(item, i) in detail.Options"
            :key="i"
            class="answer-item flex flex-align-center"
            :class="{ 'active-item': getOptionAnswer == item.OptionsId }"
            @click="handlerOption(item)"
          >
            <span class="key-eng">
              {{ getKey(i + 1) }}
            </span>
            <span class="flex-1">
              {{ item.Option }}
            </span>
            <van-icon
              v-if="getOptionAnswer == item.OptionsId"
              color="#D48806"
              name="success"
            />
          </div>
        </div>
        <!-- <van-radio-group v-model="getOptionAnswer">
          <van-cell
            v-for="item in detail.Options"
            :key="item.OptionsId"
            clickable
            :title="item.Option"
            @click="handlerOption(item)"
          >
            <template #icon>
              <van-radio checked-color="#000" :name="item.OptionsId" />
            </template>
          </van-cell>
        </van-radio-group> -->
      </div>
    </div>
    <div class="btn-box flex">
      <van-button
        block
        class="btn"
        color="#F5F6F8"
        :disabled="index === 0"
        hairline
        round
        size="large"
        type="default"
        @click="handlerPrev"
      >
        上一题
      </van-button>
      <van-button
        v-if="index !== total - 1"
        block
        class="btn"
        color="#F5F6F8"
        :disabled="!getOptionAnswer"
        hairline
        round
        size="large"
        type="primary"
        @click="handlerNext"
      >
        下一题
      </van-button>
      <van-button
        v-if="index === total - 1"
        block
        color="#000"
        :disabled="getAnswerTotal() < total"
        hairline
        round
        size="large"
        type="primary"
        @click="handleExam"
      >
        交卷
      </van-button>
    </div>
  </div>

  <div v-show="step == 3" class="step-3 h100">
    <h4>仅差最后一步了哦~</h4>
    <div style="background: #fff">
      <InfoCollection
        ref="InfoCollection"
        :config-type="10"
        is-hide-entered-info
        @submitDone="handleAllAnswer"
      />
    </div>
  </div>
  <div v-if="step == 4" class="step-3 h100 flex flex-v">
    <div class="flex-1 result-content">
      <div class="flex flex-pack-center img">
        <van-image
          height="132"
          src="https://file.tengyuone.com/1455426234329731072/2023/10/16/1713845145331306496.png"
          width="175"
        />
      </div>
      <div class="desc ql-editor" v-html="detail.BackCover"></div>
    </div>
    <div class="btns trans-content">
      <div class="btn" @click="jump">完成</div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'
  import InfoCollection from '@/components/InfoCollection/InfoCollection.vue'
  import NavBar from '@/components/NavBar'
  import store from '@/store'
  import { Toast, Dialog } from 'vant'
  import storage from '@/utils/storage'
  import { wxShare, dateFormat, detectDevice } from '@/utils'
  import { getToken } from '@/utils/token'
  export default {
    components: {
      // NavBar,
      // test
      InfoCollection,
    },
    data() {
      return {
        api,
        step: 1,
        detail: { form: {} },
        isPreview: false,
        index: 0, // 当前在第几题
        msg: {},
        init: false,
        loading: false,
        canNext: true,
        submitLoading: false,
        tenant: {},
      }
    },
    computed: {
      getTitle() {
        const answerTotal = this.getAnswerTotal()
        let title = this.detail.SurveyTitle
        if (title.length > 8) {
          title = title.substr(0, 8) + '...'
        }
        return `${title}(${answerTotal}/${this.total})`
      },
      getOptionAnswer() {
        return this.detail.Stems[this.index].OptionId
      },
      total() {
        return this.detail.Stems.length || 0
      },
    },
    watch: {
      detail: {
        handler() {
          this.saveAnser()
        },
        deep: true,
      },
    },
    mounted() {
      this.initPage()
    },
    methods: {
      getKey(key) {
        return String.fromCharCode(64 + key)
      },
      async jump() {
        const h5url = await store.getters['system/getH5Url']
        const token = getToken()
        let url = `${h5url}home/#/pages/home/index?token=${token}`
        window.location.href = url
      },
      async initPage() {
        // 统一外链链接 老链接重定向至统一外链链接
        if (this.$route.name === 'dispatch') {
          const obj = {
            name: 'SurveyDispatch',
            params: {
              id: this.$route.params.id,
            },
            query: this.$route.query,
          }

          this.$router.replace(obj)
          return
        }
        await this.getDetail()
        const tenant = await store.getters['user/getTenant']
        this.tenant = tenant
        console.log('tenant', tenant)
        if (this.detail.StandardTemplateType == 0) {
          const obj = {
            UserName: '',
            Birthday: '',
            IndustryId: '',
            CurrentIncome: '',
            TargetIncome: '',
            Wechat: '',
            Phone: '',
            // Code: '',
            FormChannel: '',
            IndustryText: '',
            FormChannelText: '',
          }
          this.detail.form = Object.assign(obj, this.detail.form)
          Object.assign(this.msg, {
            IndustryId: '请选择行业',
            FormChannel: '请选择渠道',
            UserName: '请输入姓名',
            Birthday: '请选择生日',
            IndustryText: '请选择行业',
            CurrentIncome: '请输入当前营收',
            TargetIncome: '请输入目标营收',
            Wechat: '请输入微信',
            Phone: '请输入手机号码',
            // Code: '请输入短信验证码',
            FormChannelText: '请选择渠道',
          })
        }
      },
      // 信息收集信息提交完成
      allSubmitDone() {
        this.step = 4
      },
      getAnser() {
        const answer =
          JSON.parse(storage.get('testAnswer' + this.$route.params.id)) || ''
        if (
          answer &&
          !this.isPreview &&
          // 确保分发id  与绑定的 问卷id是一致的
          answer.SurveyId === this.detail.SurveyId
        ) {
          Dialog.confirm({
            title: '温馨提示',
            message: `您之前已经回答了${answer.answerNum}题，是否继续上次回答`,
            confirmButtonText: '继续答题',
            cancelButtonText: '重新开始',
          })
            .then(() => {
              // 取得原做题数据
              this.detail = answer
              // 取得原步骤
              this.step = answer.step || 1
              // 取得原做题目标
              this.index = answer.index || 0
            })
            .catch(() => {
              this.removeAnswer()
              // on cancel
            })
        } else {
          this.removeAnswer()
        }
      },
      saveAnser() {
        const data = JSON.parse(JSON.stringify(this.detail))
        let answerNum = 0
        data.Stems.forEach((item) => {
          if (item.OptionId) {
            answerNum += 1
          }
        })
        // if (submit) {
        //   data.isSubmit = true
        // } else {
        //   data.isSubmit = false
        // }
        if (answerNum) {
          data.answerNum = answerNum
          data.step = this.step
          data.index = this.index
          storage.set(
            'testAnswer' + this.$route.params.id,
            JSON.stringify(data)
          )
        } else {
          if (this.init) this.removeAnswer()
        }
      },
      handleExam() {
        if (this.getAnswerTotal() < this.total) {
          this.Toast('请先作答完全')
          return
        }
        // 信息收集 如果 list.length>0 说明需要搜集
        const InfoCollectionList = this.$refs['InfoCollection'].QAList
        if (InfoCollectionList.length) {
          this.step = 3
        } else {
          this.handleAllAnswer()
        }
      },
      async getDetail() {
        const params = {
          businessId: this.$route.params.id,
          businessType: 1, //	业务类型1、问卷Id，2外链id
        }
        if (this.$route.name === 'SurveyDispatch') {
          params.businessType = 2
          if (this.$route.query.preview) {
            this.isPreview = true
          }
        } else {
          this.isPreview = true
        }
        this.loading = true

        return store
          .dispatch('survey/AssessmentGetDetailById', params)
          .then(async (data) => {
            this.loading = false
            const { Data } = data
            Data.Stems.forEach((item) => {
              item.OptionId = null
            })
            Object.assign(
              this.detail,
              Data.Subject,
              { Stems: Data.Stems },
              { Options: Data.Options }
            )
            this.detail.DispatchType = Data.DispatchType
            document.title = this.detail.SurveyTitle || '问卷详情'
            const TenantName = (await store.getters['user/getTenant'])
              .TenantName
            try {
              wxShare(Data.Subject.SurveyTitle, TenantName)
              this.getAnser()
            } catch (error) {
              console.log(error)
            }
            // console.log('detail', this.detail)
          })
          .catch((e) => {
            console.log(e)
            this.loading = false
            Dialog.alert({
              title: '温馨提示',
              message: e.Message || '服务器出错请稍后再试',
              confirmButtonText: '知道了',
            }).then(() => {})
            //Toast(e)
          })
      },
      getAnswerTotal() {
        let total = 0
        this.detail.Stems.forEach((item) => {
          if (item.OptionId) {
            total++
          }
        })
        return total
      },
      handlerPrev() {
        this.index--
      },
      handlerNext() {
        if (!this.detail.Stems[this.index].OptionId && !this.canNext) {
          return
        }
        if (!this.canNext) {
          return
        }
        this.canNext = false
        setTimeout(() => {
          this.canNext = true
          this.index++
        }, 100)
      },
      handlerOption(item) {
        // console.log('item', item)
        // return
        this.detail.Stems[this.index].OptionId = item.OptionsId
        if (!this.canNext) {
          return
        }
        this.canNext = false
        setTimeout(() => {
          this.canNext = true
          if (this.index < this.total - 1) this.index++
        }, 500)
      },
      async handleAllAnswer() {
        if (this.submitLoading) {
          return
        }
        if (this.isPreview) {
          Toast('当前为预览模式，数据并不会保存')
          this.step = 4
          return
        }
        this.save()
      },
      save() {
        const query = this.$route.query
        const formId = query.formId
        const params = {
          DispatchId: this.$route.params.id,
          Answers: [],
          MarketingChannelId: this.$route.query.channelId || 0,
          FlowOperationalStaff: this.$route.query.operateId || 0,
          // OperationGroupId: this.$route.query.operationGroupId || 0,
          matrixXId: this.$route.query.matrixXId || 0,
          matrixYId: this.$route.query.matrixYId || 0,
          matrixAccountId: this.$route.query.matrixAccountId || 0,
          PhoneSystem: detectDevice() || '/',
        }
        if (formId) {
          params.formId = formId
        }
        this.detail.Stems.forEach((item) => {
          params.Answers.push({ StemId: item.StemId, OptionId: item.OptionId })
        })
        this.submitLoading = true
        Toast.loading('正在提交')
        store
          .dispatch('survey/AssessmentAnswer', params)
          .then((data) => {
            const { Data, Code, Message } = data
            if (Code === 0) {
              this.checkSubmit(Data.resultId)
              setTimeout(() => {
                Toast.success('提交成功！')
                setTimeout(() => {
                  this.allSubmitDone()
                  this.submitLoading = false
                  this.removeAnswer()
                  Toast.clear()
                }, 500)
              }, 500)
            } else {
              Toast.fail(Message || '提交失败，请稍后再试')
            }
          })
          .catch((e) => {
            this.submitLoading = false
            Toast.fail(e.Message || '提交失败，请稍后再试')
          })
      },

      /**
       * 添加判断 现只用于服务云上提交时绑定数据
       * @author hanson.liu
       * @date 2022-06-29
       * @returns {any}
       */
      checkSubmit(resultId) {
        const query = this.$route.query
        const formId = query.formId
        const moduleInstanceId = query.moduleInstanceId
        const repeatId = query.repeatId
        const params = {
          formId,
          moduleInstanceId,
          resultId,
          surveyType: 2,
        }
        if (repeatId) params.HistoricalDeliveryId = repeatId
        if (formId && moduleInstanceId) {
          store.dispatch('system/ConsultationSheetSubmitCallback', params)
          window.parent.postMessage('submit', '*')
        }
      },
      removeAnswer() {
        storage.remove('testAnswer' + this.$route.params.id)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .list-enter-active,
  .list-leave-active {
    transition: all 0.6s ease 0s;
  }

  .list-leave-from {
    display: none;
  }
  .list-leave-to {
    display: none;
  }

  .list-enter-from {
    transform: translateX(10%);
    opacity: 0.5;
  }

  .list-enter-to {
    opacity: 1;
    transform: translateX(0%);
  }

  .step-1 {
    overflow-y: auto;
    height: 100vh;
    background: linear-gradient(240deg, #fde4b1 0%, rgba(243, 244, 251, 0) 30%);
    .avatar-image {
      border: 3px solid #fff;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.16),
        0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      margin-bottom: 44px;
    }
    .ql-editor {
      padding: 0;
      padding-top: 16px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      font-family: PingFangSC-Regular, PingFang SC;
      text-align: left !important;
      ::v-deep .ql-align-center {
        text-align: left;
      }
    }
    .detail-content {
      padding: 0 40px;
      box-sizing: border-box;
      .survery-title {
        font-size: 22px;
        text-align: center;
        font-weight: 500;
        color: #000000;
        line-height: 30px;
      }
      .survery-sub-title {
        margin-top: 4px;
        font-size: 16px;
        text-align: center;
        color: rgba(0, 0, 0, 0.45);
        line-height: 22px;
      }
    }
    .btn-box {
      margin-top: 88px;
      position: relative;
      padding-right: 8px;
      box-sizing: border-box;
      text-align: center;
      position: sticky;
      bottom: 0;
      left: 0;
      right: 8px;
      .btn-box-2 {
        padding: 2px 42px 41px;
        background: #fff;
      }
      &::before {
        content: '';
        position: absolute;
        top: -45px;
        right: 8px;
        left: 0;
        // width: 100%;
        height: 45px;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.9) 100%
        );
      }
    }
  }
  .question {
    position: relative;
  }
  .step-2 {
    height: 100vh;
    padding-top: 13px;
    box-sizing: border-box;
    background: #fff;
    .step-2-content {
      padding-bottom: 20px;
      box-sizing: border-box;
      overflow-y: auto;
    }
    .key-eng {
      margin-right: 10px;
    }
    .question-title {
      color: #000;
      font-size: 16px;
      padding: 28px 20px 31px;
      box-sizing: border-box;
      line-height: 22px;
    }
    .progress-div {
      padding: 0 20px;
      box-sizing: border-box;
      .progress-title {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.55);
        margin-right: 8px;
      }
      .done-total {
        color: #4aa723;
        font-size: 20px;
        margin-right: 5px;
      }
      .total {
        color: rgba(0, 0, 0, 0.4);
      }
      .top {
        margin-bottom: 8px;
      }
    }
    // .question {
    //   h2 {
    //     font-size: 18px;
    //     line-height: 1.4;
    //     padding: 16px 20px;
    //     color: #555;
    //   }
    // }
    .answer-list {
      padding: 0 20px;
      box-sizing: border-box;
      .answer-item {
        padding: 15px 17px;
        box-sizing: border-box;
        background: rgba(8, 30, 66, 0.03);
        // box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.16);
        border-radius: 8px;
        &.active-item {
          background: rgba(250, 173, 20, 0.14);
          color: #d48806;
        }
      }
      .answer-item + .answer-item {
        margin-top: 15px;
      }
    }
    .btn-box {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: -13px;
        right: 0;
        width: 100%;
        height: 15px;
        background: linear-gradient(
          to bottom,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 1) 100%
        );
      }
      padding: 20px 20px 50px;
      box-sizing: border-box;
      .van-button + .van-button {
        margin-left: 10px;
      }
      .btn {
        color: #000 !important;
      }
    }
    ::v-deep .van-cell__title {
      margin-left: 10px;
      font-size: 16px;
      color: #555;
    }
  }
  .top-submit {
    color: #1989fa;
    &.disabled {
      color: #999;
    }
  }
  .preview {
    position: fixed;
    right: 10px;
    top: 10px;
    color: #999;
    z-index: 999;
    background: #fff;
  }
  .step-3 {
    position: relative;
    background: #fff;
    // min-height: 90vh;
    width: 100%;
    height: 100vh;
    .result-content {
      overflow-y: auto;
      position: relative;
      .img {
        padding-top: 50px;
        padding-bottom: 15px;
        box-sizing: border-box;
      }
      .ql-editor {
        padding: 0 40px;
        box-sizing: border-box;
        height: auto;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        text-align: center;
      }
    }
    .btns {
      padding: 25px 0 50px;
      box-sizing: border-box;
      &.trans-content {
        position: relative;
        &::before {
          content: '';
          position: absolute;
          top: -50px;
          right: 0;
          width: 100%;
          height: 54px;
          background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 1) 100%
          );
        }
      }
      .btn {
        margin: 0 auto;
        text-align: center;
        width: 200px;
        height: 46px;
        line-height: 46px;
        background: #f5f6f8;
        border-radius: 23px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
      }
    }
    .btn-box {
      padding: 10px 60px;
    }
  }
  h4 {
    margin: 0;
    padding: 20px 16px 12px;
    text-align: center;
    font-weight: normal;
    font-size: 16px;
    color: #666;
  }
</style>
